import { Sub } from "@superwall-me/schema"
import { defaultDivComponent } from "app/paywallBuilderV2/components/ElementDetails/utils"
import { createComponentId } from "app/paywallBuilderV2/helpers"
import { TElement } from "app/schema/paywallTemplate/element/element"
import _ from "lodash"

export const migrateProductsSubstitutions = (
  substitutions: Sub[],
  mainContent: TElement
): Sub[] => {
  const drawerComponent = mainContent?.find((child) => child.name === "drawer")

  if (!drawerComponent) return substitutions

  const productsComponent = drawerComponent.children.find((child) => child.name === "products")

  if (!productsComponent) return substitutions

  const productsComponentId = productsComponent.id

  return _.map(substitutions, (sub) => {
    // We're removing padding from the drawer component, so we need to add some
    // the any Products component that is a child of the drawer so the paywall
    // renders exactly the same as the previous migration script.
    if (sub.key === `Products ${productsComponentId.toLowerCase()}`) {
      return {
        ...sub,
        properties: [
          ...(sub.properties || []),
          {
            prefix: "default",
            property: {
              type: "styles",
              styles: [
                { property: "padding-right", value: "var(--sw-container-padding)" },
                { property: "padding-left", value: "var(--sw-container-padding)" },
              ],
            },
          },
        ],
      }
    }
    return sub
  })
}

export const drawerChildrenMigrationScripts = (mainContent: TElement[]): TElement[] => {
  if (!mainContent) return []

  return mainContent.map((element) => {
    if (element.name === "drawer") {
      const productsIndex = element.children.findIndex((child) => child.name === "products")

      const aboveProducts = element.children.slice(0, productsIndex)
      const restComponents = element.children.slice(productsIndex)

      if (!aboveProducts.length) {
        return element
      } else {
        return {
          ...element,
          children: [
            {
              id: createComponentId(),
              ...defaultDivComponent,
              settings: {
                ...defaultDivComponent.settings,
                initialStyles: {
                  paddingTop: "calc(var(--sw-container-padding) * 1.6)",
                  paddingRight: "calc(var(--sw-container-padding) * 1.6)",
                  paddingLeft: "calc(var(--sw-container-padding) * 1.6)",
                  paddingBottom: "calc(var(--sw-container-padding) * 0.6)",
                },
              },
              children: aboveProducts,
            },
            ...restComponents,
          ],
        }
      }
    }

    return element
  })
}
